import axios from 'axios';

export async function post(endpoint, payload) {
    return axios.post(endpoint, payload).then(response => response.data);
}

export async function get(endpoint) {
    return axios.get(endpoint).then(response => response.data);
}

export async function getOrderFlowConfig(key) {
    const rootUrl = (process.env.NODE_ENV === 'production') ? '' : 'https://dev.talkmore.no';
    const endpoint = `${rootUrl}/tmapi/OrderFlow/Configuration?key=${key}`;
    return get(endpoint);
}

export async function getZipCodeInfo(endpoint, code) {
    return get(endpoint.replace('{code}', code));
}

export async function Exists(endpoint, phoneNumber) {
    return get(endpoint.replace('{phoneNumber}', phoneNumber));
}